import type { PostHogConfig } from 'posthog-js';

/**
 * PostHog configuration
 */
export const getPostHogConfig = (): Partial<PostHogConfig> => {
  const config: Partial<PostHogConfig> = {
    api_host:
      import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
    defaults: '2025-05-24',
    capture_exceptions: true, // This enables capturing exceptions using Error Tracking
    debug: import.meta.env.DEV,
    autocapture: false, // Disable autocapture for more control
    capture_pageview: false, // We'll manually track page views
    capture_pageleave: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]',
    },
    loaded: () => {
      if (import.meta.env.DEV) {
        console.log('[PostHog] Loaded successfully');
      }
    },
    persistence: 'localStorage+cookie',
    persistence_name: 'monta_web_map_ph',
  };

  return config;
};

/**
 * Get PostHog API key from environment
 */
export const getPostHogApiKey = (): string | undefined => {
  return import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
};

/**
 * Check if PostHog is enabled
 */
export const isPostHogEnabled = (): boolean => {
  const apiKey = getPostHogApiKey();
  return !!apiKey && apiKey.length > 0;
};
